import {setMetadata} from '../../core/data-source/data-source';
import {HttpCrudDataSource, RestResponseRecord} from '../../core/data-source/http-crud.data-source';
import {fromJson} from '../../core/data-source/json.mapper';
import {HttpService, httpService} from '../../core/services/http.service';
import {AddressRecord} from '../../records/address.record';

export class SpeedZoneCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/speed-zones';

    async getForAddress(address: AddressRecord): Promise<T> {
        return httpService
            .post(
                this.apiPath + '/getForOrder',
                HttpService.paramsToQuery({latitude: address.latitude, longitude: address.longitude}),
                {headers: HttpService.FORM_DATA_HEADERS}
            )
            .then((response: any) => {
                if (response.data.success) {
                    if (response.data.rows.length) {
                        return setMetadata(
                            fromJson(this.recordClass, response.data.rows[0]),
                            fromJson(RestResponseRecord, response.data)
                        );
                    } else {
                        return null;
                    }
                } else {
                    throw response.data.errors;
                }
            });
    }
}
